import { isMobile } from 'is-mobile'
import React from 'react'
import { scroller } from 'react-scroll'

import { smoothScrollTo } from '../../utils/scroll'
import './styles.css'

export type CalculatorState = {
  questionsComplete: number
}

export abstract class CalculatorComponent<P, S extends CalculatorState> extends React.Component<
  P,
  S
> {
  abstract totalQuestions: number

  completeQuestion = (question: number, scrollToNext?: boolean) => {
    this.setState(state => {
      if (question > state.questionsComplete) {
        return {
          questionsComplete: question,
        }
      }
    })
    if (scrollToNext || isMobile()) {
      this.scrollToQuestion(question + 1)
    }
  }

  updateValue = (valueName: keyof S, question?: number, scrollToNext?: boolean) => {
    return (value: string) => {
      this.setState({
        [valueName]: value,
      } as any)
      if (question) {
        this.completeQuestion(question, scrollToNext)
      }
    }
  }

  nextQuestionButtonFor = (question: number, scrollToNext?: boolean) => {
    if (this.state.questionsComplete === question - 1) {
      return this.completeQuestion.bind(this, question, scrollToNext)
    }
    return null
  }

  renderProgress = () => {
    const onQuestion = Math.min(this.state.questionsComplete + 1, this.totalQuestions)
    const progress = (onQuestion / this.totalQuestions) * 100

    return (
      <>
        <strong>
          Question {onQuestion} of {this.totalQuestions}
        </strong>
        <div className="calculator-progress-bar">
          <div className="calculator-progress-bar-fill" style={{ width: progress + '%' }} />
        </div>
      </>
    )
  }

  private scrollToQuestion(question: number) {
    if (question <= this.totalQuestions) {
      setTimeout(() => {
        smoothScrollTo('question' + question)
      }, 1)
    }
  }
}
